import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="border-t bg-background mt-auto">
      <div className="container mx-auto px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <h3 className="font-semibold text-lg mb-3">H.J.Ä.L.P.-Portalen</h3>
            <ul className="space-y-2 text-sm">
              <li className="text-muted-foreground">Evidensbaserad Kognitiv Beteende Terapi</li>
              <li className="text-muted-foreground">Grundare och initiativtagare av H.J.Ä.L.P.</li>
              <li className="text-muted-foreground">SinnerJin-Stiftelsen Grundat 2025</li>
            </ul>
          </div>

          {/* Links Section */}
          <div>
            <h3 className="font-semibold text-lg mb-3">Länkar</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors">
                  Om oss
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Section */}
          <div>
            <h3 className="font-semibold text-lg mb-3">Juridisk information</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors">
                  Användarvillkor
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">
                  Integritetspolicy
                </Link>
              </li>
              <li>
                <Link to="/gdpr" className="text-muted-foreground hover:text-foreground transition-colors">
                  GDPR
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="border-t mt-8 pt-6 text-center text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} H.J.Ä.L.P. Alla rättigheter förbehållna.</p>
        </div>
      </div>
    </footer>
  );
}
